import React from 'react'

const Footer=()=>{
    return(
        <footer className="footer">
            <div className="container-fluid">
                <nav>
                <p className="copyright text-center">
                    Bali Algoritm Web & Software Developer 
                </p>
                </nav>
            </div>
        </footer>

    )
}
export default Footer




// WEBPACK FOOTER //
// ./src/component/Footer/index.js